import { AccessControlType } from '@schemas'
import type { UserMenuAccessType, CrudStrType, MenuType } from '@redux/types'
import config from '@configs'

export const AccessControlManager = {
	getUserMenuAccessList: (accessControls: AccessControlType[]) => {
		const adminMenu = config.adminMenu()

		const result = accessControls.reduce(
			(acc: UserMenuAccessType[], anAccessControl: AccessControlType) => {
				const thisAdminArr = adminMenu.filter(
					anAdmin => anAdmin.id === anAccessControl.menuId,
				)

				const isAdmin = thisAdminArr.length > 0
				const newAccess: UserMenuAccessType = {
					menuGroup: isAdmin ? 'admin' : 'main',
					menuId: isAdmin ? thisAdminArr[0].id : anAccessControl.menuId,
					menuName: isAdmin ? thisAdminArr[0].name : anAccessControl.menuName,
					crud: anAccessControl.crud as CrudStrType,
					uri:
						isAdmin && thisAdminArr[0].to !== undefined
							? thisAdminArr[0].to
							: isAdmin && thisAdminArr[0].to === undefined
							? ''
							: anAccessControl.menuUri,
					path:
						isAdmin && thisAdminArr[0].to !== undefined
							? `root/${thisAdminArr[0].to}`
							: anAccessControl.menuPath,
				}
				const index = acc.findIndex(
					(aMenuAccess: UserMenuAccessType) =>
						aMenuAccess.menuId === anAccessControl.menuId,
				)

				const res: UserMenuAccessType[] =
					index === -1
						? acc.concat(newAccess)
						: (() => {
								const prevCrudArr: string[] = acc[index].crud.split('') ?? []
								const newCrudArr: string[] = newAccess.crud.split('') ?? []
								const mergedCrudArr: string[] = [
									...new Set([...prevCrudArr, ...newCrudArr]),
								]

								acc[index].crud = mergedCrudArr.join('') as CrudStrType
								return acc
						  })()

				return res
			},
			[],
		)

		return result
	},

	getMainMenuList: (params: {
		mode: 'main' | 'admin'
		userAccessMenuList: UserMenuAccessType[]
		mainMenu: MenuType[]
		adminMenu: MenuType[]
	}) => {
		const { mode, userAccessMenuList, mainMenu, adminMenu } = params
		const userAccessMenuIdArr: string[] = userAccessMenuList.map(
			anAccessMenu => anAccessMenu.menuId,
		)

		const result: MenuType[] =
			mode === 'admin'
				? (() => {
						const res: MenuType[] = adminMenu.filter(anAdminMenu => {
							return userAccessMenuIdArr.includes(anAdminMenu.id)
						})

						return res
				  })()
				: ((): MenuType[] => {
						const res: MenuType[] = mainMenu.filter((aMainMenu: MenuType) => {
							return userAccessMenuIdArr.includes(aMainMenu.id)
						})

						return res
				  })()

		return result
	},
	isAllowedAdminMenu: (userAccessMenuList: UserMenuAccessType[]) => {
		const res = userAccessMenuList.findIndex(aUserAccessMenu =>
			aUserAccessMenu.menuId.startsWith('admin'),
		)
		return res > -1
	},
}
